/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, {useCallback, useEffect, useState, useRef} from "react";
import { Container, Row, Button,Col } from "react-bootstrap";
import "./Contactus.css";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import axios from "axios";
import { useParams } from 'react-router-dom';
import MediaQuery from "react-responsive";
import content from '../content.json';
import parse from 'html-react-parser';
 
export default function Contactus({ dataJson, realtorData, loanOfficerData, newData}) {
  const [showFormModal, setShowFormModal] = useState(false);
  const [loanPurposeKwd, setLoanPurposeKwd] = useState("");
  const [frmHeading, setFrmHeading] = useState("");
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();
  const [loanOfficerUid, setLoanOfficerUid] = useState('');
  const { loName } = useParams();
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {ssid}= newData?.loanOfficer || {};


  useEffect(() => {
    /**
     * @author Akhilesh Rajput
     * @date 01/02/2024
     * The below function is used to fetch the swmc footer data which
     * is stored in master JSON in S3 bucket.
     * @returns JSON Object of the requested file
     */
    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []); 

  const handleApplyNowModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("");
    setFrmHeading("Apply Now");
  };
  const [node, setNode] = useState(null);
  const formRef = useCallback((node) => {
          // node refers to the name input field in the BorrowerLeadGenerationTool
       setNode(node);
       }, []);
  const handleCloseFormModal = () => setShowFormModal(false);

  const imgCDNURL = process.env.REACT_APP_HOMEOWNERSHIP_PROGRAM_CDN_URL ;
  const {formTitle, disclaimer } = dataJson;

  return (
    <>
     <Container>
          <Row className="lastpara pb-3">
          <p>{parse(disclaimer)}
      </p>
          </Row>
        </Container>
     <Container>
      <Row className="borrtoolrow mb-3">
        <Col xs={12} sm={12} md={12} xl={1} xxl={1} lg={1}></Col>
        <Col className="borrleadtoolcol" xs ={11} sm={12} md={12} xl={12} xxl={12} lg={12}>
            <div className="request">
              <h5>{parse(formTitle)}</h5>
            </div>
      <BorrowerLeadGenerationTool
          leadSource="POPLEAD017"
          branch=""
          showModalBackBtn={false}
          // statesDomain={process.env.REACT_APP_STATE_DOMAIN}
          ref={formRef}
          loanOfficerUid={ssid}
          mainBtnName="Tell Me More"
        />    
        </Col>
        <Col sm={12} md={12} xl={1} xxl={1} lg={1}></Col>
        </Row>
      </Container>
    </>
  );
}
